import isPropValid from '@emotion/is-prop-valid';
import { type SerializedStyles } from '@emotion/react';
import tw, { css, styled } from 'twin.macro';

export type CloseIconVariant = 'close_icon' | 'close_icon_basic_light' | 'close_icon_basic_dark';

const sharedStylesCloseIconBasic = css`
  ${tw`flex items-center justify-center`}
  ${tw`w-[34px] h-[34px]`}
`;

export const variants: Record<CloseIconVariant, SerializedStyles> = {
  close_icon_basic_light: css`
    ${sharedStylesCloseIconBasic}
    svg * {
      ${tw`fill-neutrals-n1`}
    }
  `,

  close_icon_basic_dark: css`
    ${sharedStylesCloseIconBasic}
    svg * {
      ${tw`fill-neutrals-n7`}
    }
  `,

  close_icon: css`
    ${tw`relative`}
    ${tw`transition-colors duration-150 ease-in`}
    ${tw`bg-neutrals-n1 dark:bg-primary-p1`}
    ${tw`hover:before:bg-ui-colours-ui2`}

    &:before, &:after {
      ${tw`absolute`}
      ${tw`w-[calc(100% + 4px)] h-[calc(100% + 4px)]`}
      ${tw`-top-[2px] -left-[2px] right-0 bottom-0`}
      ${tw`rounded-full`}
      ${tw`[content: '']`}
    }

    ${tw`dark:before:bg-neutrals-n1`}

    &:before {
      ${tw`transition-colors duration-150 ease-in`}
      ${tw`-z-[1]`}
    }

    &:after {
      ${tw`bg-secondary-s1`}
      ${tw`-z-[2]`}
    }

    ${tw`flex items-center justify-center`}
    ${tw`w-[34px] h-[34px]`}
    ${tw`rounded-full`}

    &:hover {
      * {
        ${tw`fill-ui-colours-ui2`}
      }
    }

    svg {
      ${tw`scale-[1.4]`}

      * {
        ${tw`fill-secondary-s1 dark:fill-neutrals-n1`}
      }
    }
  `,
};

export const StyledCloseIcon = styled('span', {
  shouldForwardProp: (propName) => isPropValid(propName) && !['variant'].includes(propName),
})<{
  variant: CloseIconVariant;
}>`
  ${({ variant }) => css`
    ${variants[variant]}
  `}
`;
